import React, { useState, useEffect, useContext  } from 'react';
import { AppContext } from '../../context';
import {withRouter, NavLink} from 'react-router-dom';
import { Nav, NavItem, TabContent, TabPane, Row, Col  } from "reactstrap";
import classnames from "classnames";
import { asyncHandler, addLocalValue, deleteLocalValue, updateLocalValue } from '../../utils';
import { restrictedEmails } from '../../components/adminEmails';

import AppLayout from '../../components/AppLayout';

import Employees from '../../components/hr/Employees'; 
import Access from '../../components/hr/Access';
import styled from 'styled-components';
import useAppData from '../../customHooks/useAppData';
import apiClient from '../../apiClient';

const HumanResources = ({
    eightyWindow, 
}) => {

    const { user, setLoading } = useContext(AppContext);
    const { stations } = useAppData();
    const [activeFirstTab, setActiveFirstTab] = useState('1');
    const [accessLevels, setAccessLevels] = useState([]);
    const [accessTabs, setAccessTabs] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [airlines, setAirlines] = useState([]);
    const [nativeAccessMapSchema, setNativeAccessMapSchema] = useState({});

    const units = (stations || []).map(s => s.s_unit);

    useEffect(() => {
        const getAccessData = asyncHandler(async () => {
            setLoading(true);
            const response = await apiClient.get(`/getAccessData/${user.s_unit}`);
            setLoading(false);
            const { accessLevels, accessTabs, employees, nativeAccessMapSchema } = response.data;
            setAccessLevels(accessLevels);
            setAccessTabs(accessTabs);
            setEmployees(employees);
            setNativeAccessMapSchema(nativeAccessMapSchema);
        });
        getAccessData();
    }, [user.s_unit]);

    const getAirlines = asyncHandler(async() => {
        const res = await apiClient.get('/selectAllAirlines');
        setAirlines(res.data);
    });
    
    const toggleTab = (tab) => {
        if (activeFirstTab !== tab) {
            setActiveFirstTab(tab);
        }   
    }

    return (
        <AppLayout>
            <div className={`card queue-card-container`} style={{ height: 'calc(100vh - 120px)', overflowY: 'scroll', overflowX: 'hidden'}}>
                <div className="card-body mb-5 px-1 py-1">
                    <Row className='px-3 py-3'>
                        <Col md='12' lg='12'>
                            <FlexContainer>
                                <h1>Human Resources</h1>
                                <h3>(Current Unit: {user.s_unit})</h3>
                            </FlexContainer>
                            <Row className='mt-2'>
                                <Col mg='12' lg='12'>
                                    <Nav tabs className="separator-tabs ml-0 mb-2">
                                        <NavItem>
                                            <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active: activeFirstTab === "1",
                                                "nav-link": true
                                            })}
                                            onClick={() => {
                                                toggleTab("1");
                                            }}
                                            >
                                            Internal Users
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                            location={{}}
                                            to="#"
                                            className={classnames({
                                                active: activeFirstTab === "2",
                                                "nav-link": true
                                            })}
                                            onClick={() => {
                                                toggleTab("2");
                                            }}
                                            >
                                            External Users
                                            </NavLink>
                                        </NavItem>
                                        {
                                            restrictedEmails.includes(user && user.s_email && user.s_email.toLowerCase()) &&
                                            <NavItem>
                                                <NavLink
                                                location={{}}
                                                to="#"
                                                className={classnames({
                                                    active: activeFirstTab === "3",
                                                    "nav-link": true
                                                })}
                                                onClick={() => {
                                                    toggleTab("3");
                                                }}
                                                >
                                                Access
                                                </NavLink>
                                            </NavItem>
                                        }
                                    </Nav>
                                </Col>
                            </Row>

                            <TabContent activeTab={activeFirstTab} className='mt-2'>
                                <TabPane tabId="1">
                                    <Employees 
                                        user={user}
                                        units={units}
                                        employees={employees.filter(e => e.b_internal)}
                                        setEmployees={setEmployees}
                                        accessLevels={accessLevels}
                                        eightyWindow={eightyWindow}
                                        getAirlines={getAirlines}      
                                        airlines={airlines}    
                                        setLoading={setLoading}     
                                        nativeAccessMapSchema={nativeAccessMapSchema}            
                                    />
                                </TabPane>
                                <TabPane tabId={'2'}>
                                    <Employees 
                                        user={user}
                                        units={units}
                                        employees={employees.filter(e => !e.b_internal)}
                                        setEmployees={setEmployees}
                                        accessLevels={accessLevels}
                                        eightyWindow={eightyWindow}
                                        getAirlines={getAirlines} 
                                        airlines={airlines}
                                        setLoading={setLoading}
                                        nativeAccessMapSchema={nativeAccessMapSchema}                            
                                    />
                                </TabPane>
                                <TabPane tabId={'3'}>
                                    <Access 
                                        user={user}
                                        accessLevels={accessLevels}
                                        setAccessLevels={setAccessLevels}
                                        accessTabs={accessTabs}
                                        asyncHandler={asyncHandler}
                                        addLocalValue={addLocalValue}
                                        deleteLocalValue={deleteLocalValue}
                                        updateLocalValue={updateLocalValue}
                                    />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </div>



        </AppLayout>
    );
}

export default withRouter(HumanResources);

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: baseline;
`;